var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.initProps = function () {

}

EHDI.scene.TitleScene.prototype.initGraphics = function () {
    // this.title = new EHDI.aka.PixiText("The Weeds Among The Grass", {fontFamily: 'Exo-Bold', fill: 0xFFFFFF, fontSize : 50});
  
    this.title = new EHDI.aka.Sprite(EHDI.Assets.images['logo_weeds1']);
    this.title.anchor.set(0.5, 0.5);    
    this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.5);

    this.spark = new EHDI.aka.Sprite(EHDI.Assets.images['logo_weeds2']);
    this.spark.anchor.set(0.5, 0.5);    
    this.spark.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.5);
    this.spark.alpha =0;

    this.gizmo =new EHDI.aka.Sprite(EHDI.Assets.images['gizmo_weeds']);
    this.gizmo.anchor.set(0.5, 0.75);    
    this.gizmo.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.45);
    
    this.addChild(this.spark);
    this.addChild(this.gizmo);
    this.addChild(this.title);

    this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
    this.sound.setOnClickFunction(this.toggleAudio);
    this.sound.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.1, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
    this.addChild(this.sound);
    
    // this.highScoreHolder = new EHDI.components.HighScoreHolder(this, EHDI.GAME.saveData.highScore);
    // this.highScoreHolder.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.723, EHDI.GAME.sceneManager.getStageHeight() * 0.0417);
    
    this.playBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], EHDI.Assets.images["btn_play2"], null, null);
    this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.85);
    this.addChild(this.playBtn);
    this.playBtn.setOnClickFunction(this.startGame);
    
    this.playTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_PLAY"));
    this.playTxt.anchor.set(0.75, 0.5);
    this.playBtn.addChild(this.playTxt);
    
    var tlPhase2 = function()
    {
        this.tl.kill();
        this.tl = null;

        this.tl2 = new TimelineMax({repeat: -1, yoyo:true});   
        this.tl2.from(this.spark, 2, {scaleX:0.5, scaleY:0.5,});
        this.spark.alpha =1;

    }

    this.tl = new TimelineMax({repeat: 0});   
    this.tl.from(this.title, 1, {scaleX:0, scaleY:0, ease: Elastic.easeOut});
    this.tl.from(this.gizmo, 0.5, {scaleX:0, scaleY:0, ease: Back.easeOut});
    this.tl.from(this.playBtn, 0.25, {scaleX:0, scaleY:0, ease: Back.easeOut});
    this.tl.add(tlPhase2.bind(this));

    /*
    if(!EHDI.GAME.debugUtils) {
        EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.3.6");
        // EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
    }*/
}

EHDI.scene.TitleScene.prototype.initListeners = function () {
    
}

EHDI.scene.TitleScene.prototype.killProps = function () {
    
}

EHDI.scene.TitleScene.prototype.killGraphics = function () {
    if(this.tl != null) this.tl.kill();
    delete this.tl;

    if(this.tl2 != null) this.tl2.kill();
    delete this.tl;

    if(this.playTxt != null)
    {
        this.removeChild(this.playTxt);
        this.playTxt.destroy({children: true});
    }
    delete this.playTxt;

    if(this.playBtn != null)
    {
        this.removeChild(this.playBtn);
        this.playBtn.destroy({children: true});
    }
    delete this.playBtn;

    if(this.sound != null)
    {
        this.removeChild(this.sound);
        this.sound.destroy({children: true});
    }
    delete this.sound;

    if(this.gizmo != null)
    {
        this.removeChild(this.gizmo);
        this.gizmo.destroy({children: true});
    }
    delete this.gizmo;

    if(this.spark != null)
    {
        this.removeChild(this.spark);
        this.spark.destroy({children: true});
    }
    delete this.spark;

    if(this.title != null)
    {
        this.removeChild(this.title);
        this.title.destroy({children: true});
    }
    delete this.title;

    if(this.bg != null)
    {
        this.removeChild(this.bg);
        this.bg.destroy({children: true});
    }
    delete this.bg;
}

EHDI.scene.TitleScene.prototype.killListeners = function () {
    
}

EHDI.scene.TitleScene.prototype.screenWillAppear = function() {
    var bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["bg_logo_weeds"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());
    
    this.addChild(bg);
};

EHDI.scene.TitleScene.prototype.screenDidAppear = function() {
    this.initProps();
    this.initGraphics();
    this.initListeners();

    if(!EHDI.GAME.bgm)
    {
        EHDI.GAME.soundManager.autoResumeToggle(true);
        EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("bgm", .5);
    }

    
};

EHDI.scene.TitleScene.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.saveData.isMuted = enable;
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, EHDI.GAME.saveData);
}


EHDI.scene.TitleScene.prototype.startGame = function() {
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.gameObject = new EHDI.scene.GameScene();
    EHDI.GAME.sceneManager.changeScene(EHDI.GAME.gameObject, {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25});
};

EHDI.scene.TitleScene.prototype.screenDidDisappear = function() {
    this.killListeners();
    this.killGraphics();
    this.killProps();
    
    this.destroy({children: true});
    // delete this;
}

EHDI.scene.TitleScene.prototype.dispose = function() {
    this.killListeners();
    this.killGraphics();
    this.killProps();
}
